module.exports = __webpack_public_path__ + "static/media/principe.d8dee2f7.jpg";